import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start from 23:59:49
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 49
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-3 md:gap-5" data-id="element-82">
      <div className="flex flex-col items-center" data-id="element-83">
        <span className="text-5xl md:text-7xl lg:text-8xl text-red-600 tracking-tight font-[700] font-[Poppins,_sans-serif]" data-id="element-84">
          {formatNumber(timeLeft.hours)}
        </span>
        <span className="text-xs font-sans text-gray-400 mt-1 uppercase tracking-widest" data-id="element-85">
          hs
        </span>
      </div>
      <span className="text-4xl md:text-6xl lg:text-7xl font-bold text-red-600 pb-5" data-id="element-86">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-87">
        <span className="text-5xl md:text-7xl lg:text-8xl font-bold text-red-600 tracking-tight font-[Poppins,_sans-serif]" data-id="element-88">
          {formatNumber(timeLeft.minutes)}
        </span>
        <span className="text-xs font-sans text-gray-400 mt-1 uppercase tracking-widest" data-id="element-89">
          min
        </span>
      </div>
      <span className="text-4xl md:text-6xl lg:text-7xl font-bold text-red-600 pb-5" data-id="element-90">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-91">
        <span className="text-5xl md:text-7xl lg:text-8xl font-bold text-red-600 tracking-tight font-[Poppins,_sans-serif]" data-id="element-92">
          {formatNumber(timeLeft.seconds)}
        </span>
        <span className="text-xs font-sans text-gray-400 mt-1 uppercase tracking-widest" data-id="element-93">
          seg
        </span>
      </div>
    </div>;
}